import React, { Component } from 'react';
import constants from '../../constants';
import { withPage, isIOS } from '../util';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import Header from '../header';
import Create from '../create';
import Schedule from '../schedule';
import Settings from '../settings';
import './home.css';
import './fade.css';

const { CREATE, SCHEDULE, SETTINGS } = constants.pages;

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      create: 'right',
      schedule: 'left',
      settings: 'left'
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.page !== nextProps.page) {
      switch (this.props.page + nextProps.page) {
        case SETTINGS + CREATE:
          this.setState({ settings: 'left', create: 'right' });
          return;
        case SETTINGS + SCHEDULE:
          this.setState({ settings: 'left', create: 'right' });
          return;
        case SCHEDULE + SETTINGS:
          this.setState({ schedule: 'right', settings: 'left' });
          return;
        case SCHEDULE + CREATE:
          this.setState({ schedule: 'left', create: 'right' });
          return;
        case CREATE + SCHEDULE:
          this.setState({ settings: 'left', create: 'right' });
          return;
        case CREATE + SETTINGS:
          this.setState({ settings: 'left', create: 'right' });
          return;
      }
    }
  }

  render() {
    const { page } = this.props;
    return (
      <div className="home">
        <Header />
        <div className="main">
          <ReactCSSTransitionGroup
            transitionName="fade"
            transitionEnterTimeout={500}
            transitionLeaveTimeout={500}
          >
            {page === SCHEDULE && <Schedule key="schedule" />}
            {page === CREATE && <Create key="create" />}
            {page === SETTINGS && <Settings key="settings" />}
          </ReactCSSTransitionGroup>
          {/*  
            {page === CREATE && <Create key="create" />}
          </ReactCSSTransitionGroup>
          <ReactCSSTransitionGroup
            transitionName={`slide-${this.state.schedule}`}
            transitionEnterTimeout={500}
            transitionLeaveTimeout={500}
          >
            {page === SCHEDULE && <Schedule key="schedule" />}
          </ReactCSSTransitionGroup>
          <ReactCSSTransitionGroup
            transitionName={`slide-${this.state.settings}`}
            transitionEnterTimeout={500}
            transitionLeaveTimeout={500}
          >
            {page === SETTINGS && <Settings key="settings" />}
          </ReactCSSTransitionGroup> */}
        </div>
      </div>
    );
  }
}

export default withPage(Home);



// WEBPACK FOOTER //
// ./src/components/home/index.js